import { fetchAuthSession } from 'aws-amplify/auth';
import { apiGet, apiPost } from '../utils/api';

const API_NAME = 'coreAdmin';
const PATH = '/coreadmin/domains';

async function getIdToken() {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (!token) {
    throw new Error('Not authenticated');
  }
  return token;
}

export async function listDomains() {
  const token = await getIdToken();
  return apiGet(API_NAME, PATH, token);
}

export async function checkDomainAvailability(domainName) {
  const token = await getIdToken();
  return apiPost(
    API_NAME,
    PATH,
    { action: 'check-availability', domainName },
    token
  );
}

export async function registerDomain(app, domainName, durationInYears = 1) {
  const token = await getIdToken();
  return apiPost(
    API_NAME,
    PATH,
    { action: 'register', app, domainName, durationInYears },
    token
  );
}

export async function getOperationStatus(operationId) {
  const token = await getIdToken();
  return apiPost(
    API_NAME,
    PATH,
    { action: 'operation-status', operationId },
    token
  );
}

export async function attachDomain(app, domainName) {
  const token = await getIdToken();
  return apiPost(API_NAME, PATH, { action: 'attach', app, domainName }, token);
}

export async function finalizeDns(app, domainName) {
  const token = await getIdToken();
  return apiPost(
    API_NAME,
    PATH,
    { action: 'finalize-dns', app, domainName },
    token
  );
}

export async function getAssociation(app, domainName) {
  const token = await getIdToken();
  return apiPost(
    API_NAME,
    PATH,
    { action: 'get-association', app, domainName },
    token
  );
}

/**
 * Remove a domain from an Amplify app and from Route 53 (hosted zone, and
 * the registration when this account owns it). `confirm` must exactly match
 * `domainName` — the backend rejects otherwise.
 */
export async function deleteDomain(app, domainName, confirm) {
  const token = await getIdToken();
  return apiPost(
    API_NAME,
    PATH,
    { action: 'delete', app, domainName, confirm },
    token
  );
}
